import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'x-table',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './x-table.component.html',
  styleUrl: './x-table.component.scss',
})
export class XTableComponent {}
